<template>
  <div
    :style="{
      background: endText.background_color,
      '--font-size': `${endText.fontSize ?? 28}px`,
    }"
    :class="{
      'no-avatar': isHideAvatar || isKeepAvatarDesign,
      'has-footer': currentConfig.isBottomNavigationEnabled,
    }"
    class="thank-text-wrapper"
  >
    <div
      :style="{
        textAlign: endText.align,
        color: endText.color,
        fontFamily: `${FontLoader.buildFontFamily(endText.font)} !important`,
      }"
      :dir="languageDir"
      class="thank-text"
    >
      {{ endText.value }}
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import useContent from '@/composables/useContent';
import useDynamicText from '@/composables/useDynamicText';
import FontLoader from '@/js/fontLoader';
import useConfig from '@/composables/useConfig';

export default defineComponent({
  name: 'ThankYouTextComponent',

  setup() {
    const { currentContent, isHideAvatar, isKeepAvatarDesign } = useContent();
    const endText = useDynamicText(currentContent.value.attrs.endText);
    const { languageDir, currentConfig } = useConfig();

    return {
      currentContent,
      isHideAvatar,
      isKeepAvatarDesign,
      endText,
      FontLoader,
      languageDir,
      currentConfig,
    };
  },
});
</script>

<style lang="scss" scoped>
@import "@/scss/common-ui.scss";

.thank-text-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  z-index: 1;
  position: fixed;
  bottom: 0;
  right: 0;
  width: 100%;
  padding: clamp(14px, 3vmin, 32px);
  height: clamp(44px, 8.2vmin, 88px);

  @media screen and (max-width: $desktop_s_breakpoint - 1px) {
    &.has-footer {
      bottom: 64px;
    }
  }

  @media screen and (min-height: $big_vertical_screen_breakpoint) {
    &.has-footer {
      bottom: 188px;
    }
  }
}

.thank-text {
  white-space: pre-wrap;
  line-height: 1.4;
  @include font-size-responsive();

  @media (orientation: portrait) {
    width: 100%;
    margin-left: 0;
  }

  @media (orientation: landscape) {
    width: 60%;
    margin-left: 40%;
  }
}
</style>
